import { useEffect, useState } from "react";
import { useAppSelector } from "../../Reducers/store";
import { SitePage } from "../../Models/SitePage";
import SitePageApi from "../../Api/SitePageApi";
import { PageType } from "../../Enums/PageType";
import { renderHTML } from "../../Utils";
import Loader from "../Common/Loader";
import { Link, useNavigate } from "react-router-dom";
import { Button, Carousel, TextInput } from "flowbite-react";
import CommonApi from "../../Api/CommonApi";
import { toast } from "react-toastify";
import { File as ImageFile } from "../../Models/File";
import { MdCategory, MdFactory } from "react-icons/md";
import { BsFillNutFill } from "react-icons/bs";
import OrderApi from "../../Api/OrderApi";
import { Order } from "../../Models/Order";
import { SearchRequest } from "../../Models/SearchRequest";
import UpcomingEvents from "../Events/UpcomingEvents";
// import './index.css';

export default function Dashboard() {
  const navigate = useNavigate();
  const { userModel } = useAppSelector((state) => state.user);
  const [pageData, setPageData] = useState<SitePage>();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [imageFiles, setImageFiles] = useState<ImageFile[]>([]);
  const [formData, setFormData] = useState<SearchRequest>({
    searchText: localStorage.getItem("searchTextState") ?? "",
    searchPartsText: localStorage.getItem("searchPartsText") ?? "",
    manufacturers: null,
    categories: null,
    subCategories: null,
    minPrice: null,
    maxPrice: null,
    limit: 30,
    skip: 0,
    reset: false,
    equipmentType: 1,
  });
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
  };
  const onSubmit = async (e: React.ChangeEvent<HTMLFormElement>) => {
    e.preventDefault();
    localStorage.setItem("manufacturersState", "");
    localStorage.setItem("categoriesState", "");
    localStorage.setItem("subCategoriesState", "");
    localStorage.setItem("searchTextState", "");
    localStorage.setItem("minPriceState", "");
    localStorage.setItem("maxPriceState", "");
    localStorage.setItem("equipmentTypeState", "1");
    localStorage.setItem("searchTextState", formData.searchText ?? "");
    setFormData((prevData) => ({ ...prevData, searchText: "" }));
    navigate("/products/search");
  };
  useEffect(() => {
    //   getSitePages();
    checkUpdateOpenOrder();
    getSitePage();
  }, []);

  useEffect(() => {
    if (pageData) {
      getSitePageFile();
    }
  }, [pageData]);

  const getSitePage = () => {
    try {
      setIsLoading(true);
      return SitePageApi.getSitePageByPageType(PageType.HomePage.toString())
        .then((res) => {
          setPageData(res.data);
          setIsLoading(false);
        })
        .catch((err) => {
          console.error(err);
        });
    } catch (error) {
      console.error(error);
      setIsLoading(false);
    }
  };

  const getSitePageFile = () => {
    try {
      setIsLoading(true);
      if (pageData) {
        return CommonApi.GetFilesBySitePage(pageData?.id)
          .then((res) => {
            if (res.data !== null) {
              setImageFiles(res.data as ImageFile[]);
            }
            setIsLoading(false);
          })
          .catch((err) => {
            toast.error("Error: " + err);
          });
      }
    } catch (error) {
      console.error(error);
      setIsLoading(false);
    }
  };

  const handlePartsClick = () => {
    localStorage.setItem("manufacturersState", "");
    localStorage.setItem("categoriesState", "");
    localStorage.setItem("subCategoriesState", "");
    localStorage.setItem("searchTextState", "");
    localStorage.setItem("minPriceState", "");
    localStorage.setItem("maxPriceState", "");
    localStorage.setItem("equipmentTypeState", "2");
    setFormData((prevData) => ({
      ...prevData,
      searchText: "",
      equipmentType: 2,
    }));
    setTimeout(() => {
      navigate("/products/search/parts", { replace: true });
    }, 100);
  };

  const checkUpdateOpenOrder = async () => {
    if (userModel) {
      let openOrderId = 0;
      await OrderApi.checkUserOpenOrder(userModel.id)
        .then((res) => {
          if (res.data) {
            openOrderId = res.data.id;
            localStorage.setItem("openOrderId", openOrderId.toString());
          } else {
            const newOrder: Order = {
              id: 0,
              businessName: null,
              contactName: null,
              contactPhone: null,
              contactEmail: null,
              notes: null,
              dateCreated: null,
              orderStatusId: 1,
              userId: userModel.id,
              billingAddressId: null,
              shippingAddressId: null,
              orderItems: [],
              billingAddress: null,
              shippingAddress: null,
              dateSubmitted: null,
              ponumber: null,
              clientId: userModel.clientId,
              shippingMethodId: null,
              client: null,
              user: null,
            };
            OrderApi.addUpdateOrder(newOrder)
              .then((res) => {
                if (res.data.success) {
                  openOrderId = Number(res.data.affectedEntityIdentifier);
                  localStorage.setItem("openOrderId", openOrderId.toString());
                }
              })
              .catch((err) => {
                console.error(err);
                setIsLoading(false);
              });
          }
        })
        .catch((err) => {
          console.error(err);
          setIsLoading(false);
        });
      await OrderApi.getOrderItemsCount(openOrderId)
        .then((res) => {
          if (res.data !== null) {
            localStorage.setItem("orderItemsCount", res.data.toString());
            window.dispatchEvent(new Event("updateOrderItemCount"));
          }
        })
        .catch((err) => {
          console.error(err);
          setIsLoading(false);
        });
    }
  };

  return (
    <div className="w-full">
      <div className="relative w-full h-full text-center flex flex-col justify-between">
        {isLoading && <Loader />}
        <div className="bg-mainBackground">
          {pageData && imageFiles && imageFiles.length > 0 && (
            <div className="w-full mx-auto h-56 sm:h-64 xl:h-72 2xl:h-80 m-4">
              <Carousel
                slide={true}
                className=""
                slideInterval={5000}
                indicators={false}
              >
                {imageFiles.map((data) => (
                  <div
                    key={data.id}
                    className="group flex flex-col w-full mx-auto object-contain h-56 sm:h-64 xl:h-72 2xl:h-80"
                  >
                    <img
                      src={data.fileUrl!}
                      alt={pageData.title + "-image"}
                      className="h-56 sm:h-64 xl:h-72 2xl:h-80 w-auto mx-auto object-contain"
                    />
                    {/* <div className='hidden group-hover:block absolute content-end w-full h-full px-20 bg-black/50 text-white'>
                    <div className=''>Test</div>
                  </div> */}
                  </div>
                ))}
              </Carousel>
            </div>
          )}

          <div className="p-4 bg-white shadow-md">
            {pageData?.description && renderHTML(pageData?.description)}
          </div>
          <div className="flex flex-col md:flex-row  p-6 md:p-10 space-y-6 md:space-y-0 bg-black text-white justify-center">
            Our fourth generation, family-owned distributer and importer focuses
            on selling and supporting specialized agricultural and construction
            equipment in the Midwest.
          </div>
          <div className="flex flex-col md:flex-row items-center justify-center bg-white p-6 md:p-10 space-y-6 md:space-y-0">
            {/* Image */}
            <div className="w-auto md:w-[300px] flex-shrink-0">
              <img
                src="https://pricebrosstorage.blob.core.windows.net/data/sitepages/Top%20Home%20Page%20pic%20-%20Edited.png"
                alt="Equipment Promo"
                className="w-full h-auto rounded shadow-md"
              />
            </div>

            {/* Text Content */}
            <div className="md:ml-8 w-full max-w-xl text-center md:text-left">
              <h2 className="text-xl sm:text-2xl font-bold mb-4">
                EQUIPMENT TO MAKE THE JOB EASIER...
              </h2>
              <ul className="list-disc list-inside text-gray-800 space-y-1 mb-6">
                <li>Hay making & handling</li>
                <li>Grain handling & harvesting</li>
                <li>Tillage & soil tools</li>
                <li>Three point attachments</li>
                <li>Tractor & skid loader attachments</li>
                <li>Construction attachments</li>
                <li>Light Forestry & Mowing</li>
              </ul>
              <Link to="/products/manufacturers">
                <Button color="dark" className="uppercase px-6 py-2 rounded-sm">
                  Learn More
                </Button>
              </Link>
            </div>
          </div>
          <div className="py-8 px-4">
            <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 gap-4 max-w-screen-xl mx-auto">
              {[1, 2, 3, 4, 5].map((i) => (
                <img
                  key={i}
                  src={`https://pricebrosstorage.blob.core.windows.net/data/sitepages/Photo%20Collage%20${i}.jpg`}
                  alt={`Equipment ${i}`}
                  className="w-full h-[200px] object-cover rounded shadow-md"
                />
              ))}
            </div>
          </div>
          <div className="w-full py-10 hidden sm:block">
            <form onSubmit={onSubmit} className="flex ms-20 me-20">
              <TextInput
                id="searchText"
                name="searchText"
                type="text"
                placeholder="Search Wholegoods by Number, Model, or Description.."
                onChange={handleChange}
                value={formData.searchText ?? ""}
                className="w-full pr-1"
                sizing={"lg"}
              />
              <Button type="submit" className="buttonMain " size={"xl"}>
                <span className="text-xl">Search</span>
              </Button>
            </form>
          </div>
        </div>
        <div className="flex text-lg sm:text-3xl font-bold h-20 sm:h-40">
          <Link
            to={"/products/manufacturers"}
            className="flex w-1/3 bg-black text-white h-full"
          >
            <div className="m-auto">
              <div className="w-full flex justify-center ">
                <MdFactory />
              </div>
              <div className="">Manufacturers</div>
            </div>
          </Link>
          <Link
            to={"/products/categories"}
            className="flex w-1/3 bg-mainBackground h-full"
          >
            <div className="m-auto">
              <div className="w-full flex justify-center">
                <MdCategory />
              </div>
              <div>Wholegoods</div>
            </div>
          </Link>
          <div
            onClick={handlePartsClick}
            className="flex w-1/3 bg-black text-white h-full cursor-pointer"
          >
            <div className="m-auto">
              <div className="w-full flex justify-center">
                <BsFillNutFill />
              </div>
              <div>Parts</div>
            </div>
          </div>
        </div>
        <UpcomingEvents />
        <div className="bg-mainBackground py-10 px-4">
          <div className="max-w-screen-xl mx-auto text-center">
            {/* Heading & Text */}
            <h2 className="text-2xl font-bold mb-4">
              A FAMILY TRADITION SINCE 1916
            </h2>
            <p className="text-lg leading-relaxed mb-10">
              Starting as a Ford Dealership in Wichita, KS in 1916 and taking on
              the Fordson Tractor line and established Price Tractor in 1918 and
              eventually reincorporating as Price Bros Equipment in 1938 as a
              wholesale distributor of shortline equipment.
              <br />
              <br />
              The business is still owned & operated by father & son, Dick Price
              Jr and Trey Price.
            </p>

            {/* Images */}
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 justify-items-center">
              {[1, 2, 3].map((i) => (
                <img
                  key={i}
                  src={`https://pricebrosstorage.blob.core.windows.net/data/sitepages/PB%20History%20${i}.png`}
                  alt={`History ${i}`}
                  className="rounded shadow-md object-cover w-full max-w-[300px] h-[200px]"
                />
              ))}
            </div>
          </div>
        </div>
        <div className="bg-black text-white py-12 px-6">
          <div className="max-w-screen-xl mx-auto grid md:grid-cols-2 gap-10 items-center">
            {/* Left Side - Text */}
            <div>
              <h2 className="text-xl font-bold mb-4 uppercase">
                Price Bros Equipment Today
              </h2>
              <p className="mb-4">
                As a small family business, our goal is to develop relationships
                built on mutual trust and reliable service. With onsite support
                staff, team members in your region, and a management that is
                involved in daily operations, we want to be a partner you can
                depend on.
              </p>
              <p className="mb-6">
                The business has adapted with the growing needs of our
                customers. We offer innovative equipment for the farm, ranch,
                and beyond, to include construction attachments for personal and
                commercial use. We work closely with manufacturers to develop
                attachments that meet your individual needs.
              </p>
              <Link
                to="/contact"
                className="inline-block bg-yellow-300 text-black font-bold px-5 py-2 rounded hover:bg-yellow-400 transition"
              >
                MEET OUR TEAM
              </Link>
            </div>

            {/* Right Side - Image */}
            <div className="flex justify-center">
              <img
                src="https://pricebrosstorage.blob.core.windows.net/data/sitepages/image005.jpg"
                alt="Price Bros Today"
                className="rounded shadow-md w-full max-w-md object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
